"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var use_context_selector_1 = require("use-context-selector");
var SearchOutline_1 = tslib_1.__importDefault(require("@eduzz/houston-icons/SearchOutline"));
var Input_1 = tslib_1.__importDefault(require("../../../Forms/Input"));
var Portal_1 = tslib_1.__importDefault(require("../../../Portal"));
var styled_1 = require("../../../styled");
var context_1 = tslib_1.__importDefault(require("../context"));
var isMacOS = navigator.userAgent.toLowerCase().includes('mac os');
var TopbarSearch = function (_a) {
    var className = _a.className, disableShortcut = _a.disableShortcut, disableEscape = _a.disableEscape, onEnter = _a.onEnter, status = _a.status, _b = _a.placeholder, placeholder = _b === void 0 ? 'Pesquisar' : _b;
    var inputRef = (0, react_1.useRef)(null);
    var _c = tslib_1.__read((0, react_1.useState)(), 2), value = _c[0], setValue = _c[1];
    var container = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.centerPortal; });
    var onKeyDown = (0, react_1.useCallback)(function (event) {
        var input = event.currentTarget;
        if (!disableEscape && event.key === 'Escape') {
            setValue('');
            input.blur();
            return;
        }
        if (event.key !== 'Enter')
            return;
        onEnter &&
            onEnter(input.value, function () {
                setValue('');
                input.blur();
            });
    }, [disableEscape, onEnter]);
    (0, react_1.useEffect)(function () {
        var listener = function (e) {
            if (e.target !== document.body || !inputRef.current)
                return;
            var metaKey = isMacOS ? e.metaKey : e.ctrlKey;
            if (e.key.toLowerCase() !== 'k' || !metaKey)
                return;
            e.preventDefault();
            e.stopPropagation();
            inputRef.current.focus();
        };
        window.addEventListener('keydown', listener);
        return function () {
            window.removeEventListener('keydown', listener);
        };
    }, []);
    if (!container)
        return null;
    return ((0, jsx_runtime_1.jsx)(Portal_1.default, tslib_1.__assign({ target: container }, { children: (0, jsx_runtime_1.jsx)("div", tslib_1.__assign({ className: className }, { children: (0, jsx_runtime_1.jsx)(Input_1.default, { ref: inputRef, size: 'sm', startAdornment: (0, jsx_runtime_1.jsx)(SearchOutline_1.default, {}), 
                // prefix={<SearchOutlined />}
                // status={status}
                // allowClear
                errorMessage: status === 'error' ? ' ' : undefined, placeholder: placeholder, value: value, onChange: setValue, endAdornment: disableShortcut ? undefined : ((0, jsx_runtime_1.jsx)("span", tslib_1.__assign({ className: 'hts-topbar-search-shortcut' }, { children: "".concat(isMacOS ? '⌘' : 'Ctrl', "+K") }))), onKeyDown: disableShortcut ? undefined : onKeyDown }) })) })));
};
exports.default = (0, styled_1.styled)((0, react_1.memo)(TopbarSearch))(function (_a) {
    var theme = _a.theme;
    return (0, styled_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    display: flex;\n    flex: 1;\n\n    & input {\n      height: auto !important;\n    }\n\n    & .hst-fieldset-message {\n      display: none !important;\n    }\n\n    & .hts-topbar-search-shortcut {\n      box-sizing: border-box;\n      margin: 0;\n      padding: 0;\n      color: rgba(0, 0, 0, 0.88);\n      font-size: 12px;\n      line-height: 20px;\n      list-style: none;\n      display: inline-block;\n      height: auto;\n      margin-inline-end: 8px;\n      padding-inline: 7px;\n      white-space: nowrap;\n      background: rgba(0, 0, 0, 0.02);\n      border: 1px solid #d9d9d9;\n      border-radius: 4px;\n      opacity: 1;\n      transition: all 0.2s;\n      text-align: start;\n    }\n\n    ", " {\n      display: none;\n    }\n  "], ["\n    display: flex;\n    flex: 1;\n\n    & input {\n      height: auto !important;\n    }\n\n    & .hst-fieldset-message {\n      display: none !important;\n    }\n\n    & .hts-topbar-search-shortcut {\n      box-sizing: border-box;\n      margin: 0;\n      padding: 0;\n      color: rgba(0, 0, 0, 0.88);\n      font-size: 12px;\n      line-height: 20px;\n      list-style: none;\n      display: inline-block;\n      height: auto;\n      margin-inline-end: 8px;\n      padding-inline: 7px;\n      white-space: nowrap;\n      background: rgba(0, 0, 0, 0.02);\n      border: 1px solid #d9d9d9;\n      border-radius: 4px;\n      opacity: 1;\n      transition: all 0.2s;\n      text-align: start;\n    }\n\n    ", " {\n      display: none;\n    }\n  "])), theme.mediaQuery.down('md'));
});
var templateObject_1;
